import Vue from 'vue'
import Router from 'vue-router'

import login from '@/pages/pcs/login'
import manage from '@/pages/pcs/manage'



Vue.use(Router);


export default new Router({
  mode: 'history',
  data() {
    return {}
  },
  routes: [
    {
      path: '/',
      name: 'login',
      component: login,
      meta: {}
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {}
    },
    {
      path: '/admin',
      component: manage,
      name: 'manage',
      children: [
        {
              path: 'frame/*',
              name: 'frame',
              meta: {
                  title: '外链页面'
              }
          },
        {
          path: 'index/*',
          name: 'index',
          meta: {
            title: '首页'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js